import styled from 'styled-components';

interface IScCookieWrapper {
	isOpen: boolean;
}

export const ScCookieWrapper = styled.div<IScCookieWrapper>`
	width: 100vw;
	z-index: 100000;
	height: fit-content;
	bottom: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
	position: fixed;
	width: 100%;
	left: 0;
	padding: 35px 25px;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.colors.marmelade};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 15px;
	transition: all 0.5s linear;
	> svg {
		min-width: 48px;
		min-height: 48px;
	}
	p {
		font: ${({ theme }) => theme.fonts.card.textMedium};
		color: ${({ theme }) => theme.colors.strongWhite};
		width: 100%;
		a {
			font: ${({ theme }) => theme.fonts.card.textMedium};
			color: ${({ theme }) => theme.colors.strongWhite};
			text-decoration: underline;
			cursor: pointer;
		}
	}
	@media (min-width: 768px) {
		flex-direction: row;
	}
	@media (min-width: 1920px) {
		gap: 50px;
	}
`;

export const ScCookieButtonsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	width: fit-content;
	align-items: center;
	button {
		font: ${({ theme }) => theme.fonts.button.mediumSecond};
		width: 200px;
	}
	@media (min-width: 768px) {
		flex-direction: row;
	}
`;
